// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* #region Responsive Framework */
/* #endregion */
/* #region Content Items */
/* #endregion */
/* #region Color Palette */
/* #region Border Radius */
/* #endregion */
/* #region Typography */
/* #endregion */
/* #region Button */
/* #endregion */
/* #region Z-Index */
/* #endregion */
/*
  The spacing function is a simple utility that takes a multiplier and returns the corresponding 
  spacing value based on the defined spacing step. This allows for easy adjustments to the overall 
  spacing of the app by simply changing the value of \$spacing-step.

  This is made only to mirror the spacing function in the design system.

  - MRA
*/
/*
  The breakpoint mixins are utilities for handling responsive design. They allow you to write media queries 
  in a more readable and maintainable way by using named breakpoints defined in the \$breakpoints map.

  - MRA
*/
/*
  Experimental

  There are now two distinct fluid helpers in this file:

  1. \`fluid-props(\$map, \$breakpoint)\`
     Keeps the existing behavior for a group of properties.
     Static values are emitted first, and inside \`respond-down(\$breakpoint)\`
     each property scales from the provided value down toward the \`sm\`
     breakpoint using the original proportional logic.

  2. \`fluid-prop-range(...)\`
     Handles a single property with three explicit values:
     - a base value, emitted outside any media query
     - a min value, used for scaling down from \`xl\` to \`sm\`
     - a max value, used for scaling up from \`xxl\` and above

     The downscale path is a direct interpolation between the explicit
     min and base values. The upscale path reuses the same proportional
     viewport logic as the original helper, anchored to the base value,
     and clamps the result so it never exceeds the explicit max value.

  - MRA
*/
/*
  Builds a clamp() expression from two explicit values and two explicit
  breakpoints.

  This is the low-level interpolation helper used when both endpoints are
  known, for example when a property should be exactly 24px at \`sm\` and
  exactly 40px at \`xl\`.
*/
/*
  Recreates the original proportional scaling logic used by \`fluid-prop\`.

  Only the upper value is supplied. The lower value is derived from the
  ratio between the provided maximum value and its controlling breakpoint,
  then passed through \`fluid-between()\` for the final clamp() expression.
*/
/*
  Scales upward from a base value using the same proportional viewport logic
  as the original helper, then clamps that growth to an explicit max value.

  The ratio is anchored to the base value and its reference breakpoint.
  In practice this means the property keeps its base value until the viewport
  is large enough for the preferred fluid expression to exceed it, after which
  it grows smoothly until the explicit max value is reached.
*/
/*
  Single-property helper for the three-value case.

  Output behavior:
  - Base value is emitted directly, outside any media query.
  - Inside \`respond-down(\$base-name)\`, the property scales from the explicit
    min value up to the base value.
  - If \`\$max-value\` is provided, inside \`respond-up(\$max-name)\` the property
    scales upward from the base value and is clamped so it never exceeds the
    explicit max value.
  - If \`\$max-value\` is omitted (or \`null\`), no upscale media query is emitted.

  Example:
  @include utils.fluid-prop-range(font-size, 40px, 24px, 56px);

  Example without max:
  @include utils.fluid-prop-range(font-size, 40px, 24px);
*/
/*
  Group-property helper for the original xl-to-sm scaling case.

  Output behavior:
  - Each property in the map is emitted first as a static base value,
    outside any media query.
  - Inside \`respond-down(\$breakpoint)\`, every property in the map is
    recalculated with the original proportional fluid logic so it scales
    down toward the \`sm\` breakpoint.

  This helper is intended for the existing multi-property scenario where a
  component has one shared upper breakpoint and each property should shrink
  proportionally beneath it.

  Examples:
  @include utils.fluid-props((margin-top: 64px, margin-left: 52px));
  @include utils.fluid-props((margin-top: 64px), \$breakpoint: lg);
*/
/* 
  Base (1×) constants — keep in sync with tv-guide-helpers.ts
  -MRA
*/
.tv-guide__NibGY {
  position: relative;
  background-color: #011224;
  overflow: hidden;
  user-select: none;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 88px;
}
.browser-mode .tv-guide__NibGY {
  margin-left: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide__NibGY {
    margin-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.tv-guide__NibGY {
  height: calc(100vh - calc(var(--tv-scale, 1) * 150px));
}
.tv-guide__clock__y5nvK {
  position: fixed;
  top: 128px;
  right: 88px;
}
.tv-guide__scrollable-x__O_zQy {
  margin-left: calc(var(--tv-scale, 1) * 126px);
  margin-bottom: 72px;
}
.browser-mode .tv-guide__scrollable-x__O_zQy {
  margin-bottom: calc(72px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide__scrollable-x__O_zQy {
    margin-bottom: clamp(calc(calc(72px * 0.65) * 0.4583333333), calc(calc(72px * 0.65) * 0.4583333333) + (calc(72px * 0.65) - calc(calc(72px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
}
.tv-guide__grid-area__Fd3GK {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
}
.tv-guide__button-container__lX2Zj {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  margin-right: 16px;
  z-index: 100;
  width: auto;
}
.tv-guide__arrow-button-bottom__KYsY1 {
  margin-top: 8px;
}
.tv-guide__grid__x0zpc {
  position: relative;
  width: var(--grid-width);
  height: var(--grid-height);
}
.tv-guide__image__d4dXT {
  position: fixed;
  right: 0;
  top: 0;
  mask-image: radial-gradient(ellipse at 100% 27%, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 70%);
  -webkit-mask-image: radial-gradient(ellipse at 100% 27%, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 70%);
  opacity: 1;
  transition: opacity 300ms ease;
  width: 1050px;
}
.browser-mode .tv-guide__image__d4dXT {
  width: calc(1050px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide__image__d4dXT {
    width: clamp(calc(calc(1050px * 0.65) * 0.4583333333), calc(calc(1050px * 0.65) * 0.4583333333) + (calc(1050px * 0.65) - calc(calc(1050px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(1050px * 0.65));
  }
}
.tv-guide__image--hidden__aAyDq {
  opacity: 0;
}

.tv-guide-more-info__JIhUP {
  box-sizing: border-box;
  user-select: none;
  position: relative;
  z-index: 1;
  min-height: 290px;
}
.browser-mode .tv-guide-more-info__JIhUP {
  min-height: calc(290px * 0.65);
}
.tv-guide-more-info__JIhUP {
  padding-right: 88px;
}
.browser-mode .tv-guide-more-info__JIhUP {
  padding-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__JIhUP {
    min-height: clamp(calc(calc(290px * 0.65) * 0.4583333333), calc(calc(290px * 0.65) * 0.4583333333) + (calc(290px * 0.65) - calc(calc(290px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(290px * 0.65));
  }
  .browser-mode .tv-guide-more-info__JIhUP {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.tv-guide-more-info__JIhUP {
  /*
    This padding-top and padding-bottom are set to 0px at the largest breakpoint,
    and then fluidly scales up to half the page padding at the 
    smallest breakpoint. This is done to ensure that the settings 
    page has a consistent look and feel across different screen sizes, 
    while also providing enough space for the content to breathe.
    - MRA
  */
  padding-top: 0px;
}
.browser-mode .tv-guide-more-info__JIhUP {
  padding-top: calc(0px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__JIhUP {
    padding-top: clamp(calc(44px * 0.65), calc(44px * 0.65) + (calc(0px * 0.65) - calc(44px * 0.65)) * (100vw - 880px) / 1040px, calc(0px * 0.65));
  }
}
.tv-guide-more-info__JIhUP {
  padding-bottom: 0px;
}
.browser-mode .tv-guide-more-info__JIhUP {
  padding-bottom: calc(0px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__JIhUP {
    padding-bottom: clamp(calc(44px * 0.65), calc(44px * 0.65) + (calc(0px * 0.65) - calc(44px * 0.65)) * (100vw - 880px) / 1040px, calc(0px * 0.65));
  }
}
.tv-guide-more-info__period__kRDqL {
  opacity: 0.5;
}
.tv-guide-more-info__progress__hj5gz {
  border-radius: 2px;
  overflow: hidden;
  opacity: 0;
  transition: all 0.15s ease;
}
.tv-guide-more-info__progress--visible__eg5W0 {
  opacity: 1;
}
.tv-guide-more-info__progress__hj5gz {
  width: 392px;
}
.browser-mode .tv-guide-more-info__progress__hj5gz {
  width: calc(392px * 0.65);
}
.tv-guide-more-info__progress__hj5gz {
  margin-top: 16px;
}
.browser-mode .tv-guide-more-info__progress__hj5gz {
  margin-top: calc(16px * 0.65);
}
.tv-guide-more-info__progress__hj5gz {
  height: 8px;
}
.browser-mode .tv-guide-more-info__progress__hj5gz {
  height: calc(8px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__progress__hj5gz {
    width: clamp(calc(calc(392px * 0.65) * 0.4583333333), calc(calc(392px * 0.65) * 0.4583333333) + (calc(392px * 0.65) - calc(calc(392px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(392px * 0.65));
  }
  .browser-mode .tv-guide-more-info__progress__hj5gz {
    margin-top: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
  .browser-mode .tv-guide-more-info__progress__hj5gz {
    height: clamp(calc(calc(8px * 0.65) * 0.4583333333), calc(calc(8px * 0.65) * 0.4583333333) + (calc(8px * 0.65) - calc(calc(8px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(8px * 0.65));
  }
}
.tv-guide-more-info__progress-bar__Hse4q {
  width: 100%;
  border-radius: 2px;
}
.tv-guide-more-info__buttons__Gkyq3 {
  position: absolute;
  display: flex;
  right: 88px;
}
.browser-mode .tv-guide-more-info__buttons__Gkyq3 {
  right: calc(88px * 0.65);
}
.tv-guide-more-info__buttons__Gkyq3 {
  bottom: 16px;
}
.browser-mode .tv-guide-more-info__buttons__Gkyq3 {
  bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__buttons__Gkyq3 {
    right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .tv-guide-more-info__buttons__Gkyq3 {
    bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.tv-guide-more-info__button__MZB_N {
  display: flex;
  align-items: center;
  color: #f2f2f2;
  cursor: pointer;
  z-index: 2;
  margin-right: 32px;
}
.browser-mode .tv-guide-more-info__button__MZB_N {
  margin-right: calc(32px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__button__MZB_N {
    margin-right: clamp(calc(calc(32px * 0.65) * 0.4583333333), calc(calc(32px * 0.65) * 0.4583333333) + (calc(32px * 0.65) - calc(calc(32px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(32px * 0.65));
  }
}
.tv-guide-more-info__button__MZB_N svg {
  margin-right: 16px;
}
.browser-mode .tv-guide-more-info__button__MZB_N svg {
  margin-right: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-more-info__button__MZB_N svg {
    margin-right: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.tv-guide-more-info__button__MZB_N:last-child {
  margin-right: 0;
}

.tv-guide-timeline__xyTct {
  position: relative;
  display: flex;
  left: calc(var(--tv-scale, 1) * 126px);
  width: calc(var(--tv-scale, 1) * 14px * 30 * 48);
  z-index: 2;
  margin-bottom: 8px;
  transform: translateX(var(--timeline-scroll));
}
.tv-guide-timeline__item__KiJqJ {
  align-items: flex-end;
  box-sizing: border-box;
  display: flex;
  height: calc(var(--tv-scale, 1) * 56px);
  width: calc(var(--tv-scale, 1) * 14px * 30);
}
.tv-guide-timeline__item-text__BMQxr {
  transform: translateX(-50%);
}

.tv-guide-live-marker__o0XHT {
  position: absolute;
  left: calc(var(--tv-scale, 1) * 126px);
  background-color: #00c9a2;
  pointer-events: none;
  z-index: 2;
  box-shadow: 0px 8px 22px #000000;
  transform: translateX(var(--live-marker-offset-x, 0px));
  height: var(--live-marker-height);
  width: 6px;
}
.browser-mode .tv-guide-live-marker__o0XHT {
  width: calc(6px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-live-marker__o0XHT {
    width: clamp(calc(calc(6px * 0.65) * 0.4583333333), calc(calc(6px * 0.65) * 0.4583333333) + (calc(6px * 0.65) - calc(calc(6px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(6px * 0.65));
  }
}

.tv-guide-channels__aLxf1 {
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 3;
  background-color: #011224;
}
.tv-guide-channels__channel__G47fM {
  align-items: center;
  border-radius: 6px;
  display: flex;
  height: calc(var(--tv-scale, 1) * 76px);
  margin-bottom: calc(var(--tv-scale, 1) * 16px);
  justify-content: center;
  overflow: hidden;
  width: calc(var(--tv-scale, 1) * 114px);
  z-index: 3;
  position: relative;
}
.tv-guide-channels__channel__G47fM img {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.tv-guide-programs__GqEEH {
  height: 100%;
}
.tv-guide-programs__row__vd4o7 {
  height: calc(var(--tv-scale, 1) * 76px);
}
.tv-guide-programs__row-empty__mQMlS {
  border: none;
  margin: 0;
  position: absolute;
  left: 0;
  width: 100%;
  height: calc(var(--tv-scale, 1) * 76px);
  background-color: transparent;
  cursor: pointer;
}
.tv-guide-programs__row-empty--focused__zdBsa {
  outline: 2px solid #369993;
}
.tv-guide-programs__GqEEH .tv-guide-program__b5R79 {
  border: none;
  text-align: left;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: calc(var(--tv-scale, 1) * 76px);
  padding-right: 24px;
  padding-left: 24px;
  background-color: #142435;
  color: #4d5965;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.2s ease;
  border-radius: 8px;
  cursor: pointer;
  top: var(--program-top-offset, 0px);
  left: var(--program-left-offset, 0px);
  width: var(--program-width, 0px);
}
.tv-guide-programs__GqEEH .tv-guide-program--highlighted__FN2x3 {
  background-color: #233342;
  color: #f2f2f2;
}
.tv-guide-programs__GqEEH .tv-guide-program--inactive__X6RGe {
  background-color: #142435;
  color: #4d5965;
}
.tv-guide-programs__GqEEH .tv-guide-program--selected__J7tb5 {
  background-color: #f2f2f2;
  color: #011224;
}
.tv-guide-programs__GqEEH .tv-guide-program--focused__XqO_s, .tv-guide-programs__GqEEH .tv-guide-program__b5R79:hover {
  background-color: #8370f1;
  color: #f2f2f2;
}
.tv-guide-programs__GqEEH .tv-guide-program--short__l71WN {
  padding-right: 0;
  padding-left: 0;
}
.tv-guide-programs__GqEEH .tv-guide-program__container__yt_sj {
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;
  transform: translateX(var(--program-text-offset, 0px));
}
.tv-guide-programs__GqEEH .tv-guide-program__text__W2Rtu {
  white-space: nowrap;
  overflow: hidden;
  min-width: 0;
  text-overflow: ellipsis;
  width: var(--program-text-width, 0px);
}
.tv-guide-programs__GqEEH .tv-guide-program__icons__cfNMC {
  display: flex;
  align-items: center;
  position: absolute;
  right: calc(var(--tv-scale, 1) * 16px);
  top: 50%;
  transform: translateY(-50%);
}
.tv-guide-programs__GqEEH .tv-guide-program__indicator__rQG6x {
  width: calc(var(--tv-scale, 1) * 32px);
  height: calc(var(--tv-scale, 1) * 32px);
  flex-shrink: 0;
}
.tv-guide-programs__GqEEH .tv-guide-program__indicator__rQG6x svg,
.tv-guide-programs__GqEEH .tv-guide-program__indicator__rQG6x svg * {
  fill: currentColor !important;
  stroke: currentColor !important;
}

.tv-guide-dialog__calendar-date-row__rCkzs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.tv-guide-dialog__edit-favorites__XsGAD {
  margin-top: 8px;
}

/*
  Skeleton styles
*/
.tv-guide-skeleton-info__JZJqN {
  position: relative;
  min-height: 290px;
}
.browser-mode .tv-guide-skeleton-info__JZJqN {
  min-height: calc(290px * 0.65);
}
.tv-guide-skeleton-info__JZJqN {
  padding-right: 88px;
}
.browser-mode .tv-guide-skeleton-info__JZJqN {
  padding-right: calc(88px * 0.65);
}
.tv-guide-skeleton-info__JZJqN {
  margin-left: 88px;
}
.browser-mode .tv-guide-skeleton-info__JZJqN {
  margin-left: calc(88px * 0.65);
}
.tv-guide-skeleton-info__JZJqN {
  margin-right: 88px;
}
.browser-mode .tv-guide-skeleton-info__JZJqN {
  margin-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__JZJqN {
    min-height: clamp(calc(calc(290px * 0.65) * 0.4583333333), calc(calc(290px * 0.65) * 0.4583333333) + (calc(290px * 0.65) - calc(calc(290px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(290px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__JZJqN {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__JZJqN {
    margin-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__JZJqN {
    margin-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.tv-guide-skeleton-info__JZJqN {
  /*
    This padding-top and padding-bottom are set to 0px at the largest breakpoint,
    and then fluidly scales up to half the page padding at the 
    smallest breakpoint. This is done to ensure that the settings 
    page has a consistent look and feel across different screen sizes, 
    while also providing enough space for the content to breathe.
    - MRA
  */
  padding-top: 0px;
}
.browser-mode .tv-guide-skeleton-info__JZJqN {
  padding-top: calc(0px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__JZJqN {
    padding-top: clamp(calc(44px * 0.65), calc(44px * 0.65) + (calc(0px * 0.65) - calc(44px * 0.65)) * (100vw - 880px) / 1040px, calc(0px * 0.65));
  }
}
.tv-guide-skeleton-info__JZJqN {
  padding-bottom: 0px;
}
.browser-mode .tv-guide-skeleton-info__JZJqN {
  padding-bottom: calc(0px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__JZJqN {
    padding-bottom: clamp(calc(44px * 0.65), calc(44px * 0.65) + (calc(0px * 0.65) - calc(44px * 0.65)) * (100vw - 880px) / 1040px, calc(0px * 0.65));
  }
}
.tv-guide-skeleton-info__title__DLIbj {
  height: 85px;
}
.browser-mode .tv-guide-skeleton-info__title__DLIbj {
  height: calc(85px * 0.65);
}
.tv-guide-skeleton-info__title__DLIbj {
  margin-bottom: 16px;
}
.browser-mode .tv-guide-skeleton-info__title__DLIbj {
  margin-bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__title__DLIbj {
    height: clamp(calc(calc(85px * 0.65) * 0.4583333333), calc(calc(85px * 0.65) * 0.4583333333) + (calc(85px * 0.65) - calc(calc(85px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(85px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__title__DLIbj {
    margin-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.tv-guide-skeleton-info__subtitle__dc8wB {
  height: 50px;
}
.browser-mode .tv-guide-skeleton-info__subtitle__dc8wB {
  height: calc(50px * 0.65);
}
.tv-guide-skeleton-info__subtitle__dc8wB {
  margin-bottom: 16px;
}
.browser-mode .tv-guide-skeleton-info__subtitle__dc8wB {
  margin-bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__subtitle__dc8wB {
    height: clamp(calc(calc(50px * 0.65) * 0.4583333333), calc(calc(50px * 0.65) * 0.4583333333) + (calc(50px * 0.65) - calc(calc(50px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(50px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__subtitle__dc8wB {
    margin-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.tv-guide-skeleton-info__duration__OiwHW {
  height: 45px;
}
.browser-mode .tv-guide-skeleton-info__duration__OiwHW {
  height: calc(45px * 0.65);
}
.tv-guide-skeleton-info__duration__OiwHW {
  margin-bottom: 16px;
}
.browser-mode .tv-guide-skeleton-info__duration__OiwHW {
  margin-bottom: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__duration__OiwHW {
    height: clamp(calc(calc(45px * 0.65) * 0.4583333333), calc(calc(45px * 0.65) * 0.4583333333) + (calc(45px * 0.65) - calc(calc(45px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(45px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__duration__OiwHW {
    margin-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.tv-guide-skeleton-info__buttons__bpFH7 {
  position: absolute;
  bottom: 16px;
  right: 0;
  display: flex;
  width: 800px;
}
.browser-mode .tv-guide-skeleton-info__buttons__bpFH7 {
  width: calc(800px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__buttons__bpFH7 {
    width: clamp(calc(calc(800px * 0.65) * 0.4583333333), calc(calc(800px * 0.65) * 0.4583333333) + (calc(800px * 0.65) - calc(calc(800px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(800px * 0.65));
  }
}
.tv-guide-skeleton-info__button__hiGf5 {
  height: 56px;
}
.browser-mode .tv-guide-skeleton-info__button__hiGf5 {
  height: calc(56px * 0.65);
}
.tv-guide-skeleton-info__button__hiGf5 {
  margin-right: 32px;
}
.browser-mode .tv-guide-skeleton-info__button__hiGf5 {
  margin-right: calc(32px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-info__button__hiGf5 {
    height: clamp(calc(calc(56px * 0.65) * 0.4583333333), calc(calc(56px * 0.65) * 0.4583333333) + (calc(56px * 0.65) - calc(calc(56px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(56px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-info__button__hiGf5 {
    margin-right: clamp(calc(calc(32px * 0.65) * 0.4583333333), calc(calc(32px * 0.65) * 0.4583333333) + (calc(32px * 0.65) - calc(calc(32px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(32px * 0.65));
  }
}
.tv-guide-skeleton-info__button__hiGf5:last-child {
  margin-right: 0;
}

.tv-guide-skeleton-grid__kRbzD {
  display: flex;
  margin-top: 56px;
}
.browser-mode .tv-guide-skeleton-grid__kRbzD {
  margin-top: calc(56px * 0.65);
}
.tv-guide-skeleton-grid__kRbzD {
  margin-left: 88px;
}
.browser-mode .tv-guide-skeleton-grid__kRbzD {
  margin-left: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-grid__kRbzD {
    margin-top: clamp(calc(calc(56px * 0.65) * 0.4583333333), calc(calc(56px * 0.65) * 0.4583333333) + (calc(56px * 0.65) - calc(calc(56px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(56px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-grid__kRbzD {
    margin-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.tv-guide-skeleton-grid__channels___eEuv {
  width: 114px;
}
.browser-mode .tv-guide-skeleton-grid__channels___eEuv {
  width: calc(114px * 0.65);
}
.tv-guide-skeleton-grid__channels___eEuv {
  margin-right: 8px;
}
.browser-mode .tv-guide-skeleton-grid__channels___eEuv {
  margin-right: calc(8px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-grid__channels___eEuv {
    width: clamp(calc(calc(114px * 0.65) * 0.4583333333), calc(calc(114px * 0.65) * 0.4583333333) + (calc(114px * 0.65) - calc(calc(114px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(114px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-grid__channels___eEuv {
    margin-right: clamp(calc(calc(8px * 0.65) * 0.4583333333), calc(calc(8px * 0.65) * 0.4583333333) + (calc(8px * 0.65) - calc(calc(8px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(8px * 0.65));
  }
}
.tv-guide-skeleton-grid__programs__sPwRG {
  flex: 1;
}
.tv-guide-skeleton-grid__row__bIoRf {
  margin-bottom: 16px;
}
.browser-mode .tv-guide-skeleton-grid__row__bIoRf {
  margin-bottom: calc(16px * 0.65);
}
.tv-guide-skeleton-grid__row__bIoRf {
  height: 76px;
}
.browser-mode .tv-guide-skeleton-grid__row__bIoRf {
  height: calc(76px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .tv-guide-skeleton-grid__row__bIoRf {
    margin-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
  .browser-mode .tv-guide-skeleton-grid__row__bIoRf {
    height: clamp(calc(calc(76px * 0.65) * 0.4583333333), calc(calc(76px * 0.65) * 0.4583333333) + (calc(76px * 0.65) - calc(calc(76px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(76px * 0.65));
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/tv-guide/components/tv-guide.module.scss","webpack://./src/scaffold/styles/variables.scss","webpack://./src/scaffold/styles/utilities.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACOhB,iCAAA;AAeA,eAAA;AAUA,0BAAA;AAqCA,eAAA;AAEA,0BAAA;AA+EA,0BAAA;AAMA,eAAA;AAEA,uBAAA;AA+EA,eAAA;AAEA,mBAAA;AAqBA,eAAA;AAEA,oBAAA;AAOA,eAAA;ACzPA;;;;;;;;CAAA;AAcA;;;;;CAAA;AAiCA;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAyBA;;;;;;;CAAA;AAyCA;;;;;;CAAA;AA8BA;;;;;;;;CAAA;AAwCA;;;;;;;;;;;;;;;;;CAAA;AAmDA;;;;;;;;;;;;;;;;;CAAA;AFtPA;;;CAAA;AA2BA;EACE,kBAAA;EACA,yBC+CyB;ED9CzB,gBAAA;EACA,iBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EEwOE,iBFrOA;AAiFJ;AEsJI;EACE,8BAAA;AFpJN;AEzEE;EAoOI;IACE,+MAAA;EFxJN;AACF;AAnGA;EAeE,sDAAA;AAuFF;AArFE;EACE,eAAA;EACA,UAAA;EACA,WClDW;ADyIf;AApFE;EACE,6CA7BU;EEoPV,mBFpNE;AAoFN;AEkII;EACE,gCAAA;AFhIN;AE7FE;EAoOI;IACE,iNAAA;EFpIN;AACF;AAvFE;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,aAAA;AAyFJ;AAtFE;EACE,kBAAA;EACA,QAAA;EAEA,2BAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AAuFJ;AApFE;EACE,eAAA;AAsFJ;AAnFE;EACE,kBAAA;EACA,wBAAA;EACA,0BAAA;AAqFJ;AAlFE;EACE,eAAA;EACA,QAAA;EACA,MAAA;EACA,wFAAA;EACA,gGAAA;EAKA,UAAA;EACA,8BAAA;EEwKA,aFrKE;AA8EN;AEyFI;EACE,0BAAA;AFvFN;AEtIE;EAoOI;IACE,mNAAA;EF3FN;AACF;AAjFI;EACE,UAAA;AAmFN;;AA9EA;EACE,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EEsJE,iBFnJA;AA+EJ;AEsEI;EACE,8BAAA;AFpEN;AAzFA;EE0JI,mBFnJA;AAqFJ;AEgEI;EACE,gCAAA;AF9DN;AE/JE;EAoOI;IACE,mNAAA;EFlEN;EEiEI;IACE,iNAAA;EF/DN;AACF;AAvGA;EAaE;;;;;;;GAAA;EEuGA,gBF/F6C;AA6F/C;AEKE;EACE,6BARmB;AFKvB;AErLE;EAuLA;IAII,8IAAA;EFFJ;AACF;AA1HA;EEoHE,mBF9FgD;AAuGlD;AENE;EACE,gCARmB;AFgBvB;AEhME;EAuLA;IAII,iJAAA;EFSJ;AACF;AA7GE;EACE,YAAA;AA+GJ;AA5GE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,0BCtJc;ADoQlB;AA5GI;EACE,UAAA;AA8GN;AArHE;EE8HE,YFnHE;AA6GN;AEQI;EACE,yBAAA;AFNN;AA3HE;EE8HE,gBFnHE;AAmHN;AEEI;EACE,6BAAA;AFAN;AAjIE;EE8HE,WFnHE;AAyHN;AEJI;EACE,wBAAA;AFMN;AEnOE;EAoOI;IACE,8MAAA;EFEN;EEHI;IACE,8MAAA;EFKN;EENI;IACE,qMAAA;EFQN;AACF;AA/HE;EACE,WAAA;EACA,kBAAA;AAiIJ;AA9HE;EACE,kBAAA;EACA,aAAA;EEoGA,WFjGE;AA8HN;AE3BI;EACE,wBAAA;AF6BN;AAtIE;EEsGE,YFjGE;AAoIN;AEjCI;EACE,yBAAA;AFmCN;AEhQE;EAoOI;IACE,yMAAA;EF+BN;EEhCI;IACE,0MAAA;EFkCN;AACF;AAxIE;EACE,aAAA;EACA,mBAAA;EACA,cC/FU;EDgGV,eAAA;EACA,UAAA;EEqFA,kBFlFE;AAwIN;AEpDI;EACE,+BAAA;AFsDN;AEnRE;EAoOI;IACE,gNAAA;EFkDN;AACF;AA3II;EE6EA,kBF3EI;AA4IR;AE/DI;EACE,+BAAA;AFiEN;AE9RE;EAoOI;IACE,gNAAA;EF6DN;AACF;AA9II;EACE,eAAA;AAgJN;;AA3IA;EACE,kBAAA;EACA,aAAA;EACA,sCAxLY;EAyLZ,gDAAA;EACA,UAAA;EACA,kBAAA;EACA,6CAAA;AA8IF;AA5IE;EACE,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,uCAhMe;EAiMf,2CAlMc;AAgVlB;AA3IE;EACE,2BAAA;AA6IJ;;AAzIA;EACE,kBAAA;EACA,sCA7MY;EA8MZ,yBChImB;EDiInB,oBAAA;EACA,UAAA;EACA,gCAAA;EACA,uDAAA;EACA,iCAAA;EEiCE,UF9BA;AA0IJ;AE1GI;EACE,uBAAA;AF4GN;AEzUE;EAoOI;IACE,oMAAA;EFwGN;AACF;;AA5IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,yBC3KyB;AD0T3B;AA7IE;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCA5Oa;EA6Ob,8CA5OU;EA6OV,uBAAA;EACA,gBAAA;EACA,uCA9OY;EA+OZ,UAAA;EACA,kBAAA;AA+IJ;AA7II;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AA+IN;;AA1IA;EACE,YAAA;AA6IF;AA3IE;EACE,uCAnQa;AAgZjB;AA3IE;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,uCA3Qa;EA4Qb,6BAAA;EACA,eAAA;AA6IJ;AA3II;EACE,0BAAA;AA6IN;AAzIE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCA3Ra;EA4Rb,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,mCAAA;EACA,qCAAA;EACA,gCAAA;AA0IJ;AAxII;EACE,yBAAA;EACA,cC7Le;ADuUrB;AAvII;EACE,yBAAA;EACA,cAAA;AAyIN;AAtII;EACE,yBClPQ;EDmPR,cCnMY;AD2UlB;AArII;EAEE,yBCnOiB;EDoOjB,cC7Me;ADmVrB;AAnII;EACE,gBAAA;EACA,eAAA;AAqIN;AAlII;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,gBAAA;EACA,sDAAA;AAoIN;AAjII;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,qCAAA;AAmIN;AAhII;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,QAAA;EACA,2BAAA;AAkIN;AA/HI;EACE,sCAAA;EACA,uCAAA;EACA,cAAA;AAiIN;AA/HM;;EAEE,6BAAA;EACA,+BAAA;AAiIR;;AA1HE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AA6HJ;AA1HE;EACE,eAAA;AA4HJ;;AAxHA;;CAAA;AAGA;EACE,kBAAA;EEnIE,iBFsIA;AAyHJ;AE7PI;EACE,8BAAA;AF+PN;AAhIA;EElII,mBFsIA;AA+HJ;AEnQI;EACE,gCAAA;AFqQN;AAtIA;EElII,iBFsIA;AAqIJ;AEzQI;EACE,8BAAA;AF2QN;AA5IA;EElII,kBFsIA;AA2IJ;AE/QI;EACE,+BAAA;AFiRN;AE9eE;EAoOI;IACE,mNAAA;EF6QN;EE9QI;IACE,iNAAA;EFgRN;EEjRI;IACE,+MAAA;EFmRN;EEpRI;IACE,gNAAA;EFsRN;AACF;AAhKA;EAYE;;;;;;;GAAA;EEpLA,gBF4L6C;AAuJ/C;AEhVE;EACE,6BARmB;AF0VvB;AE1gBE;EAuLA;IAII,8IAAA;EFmVJ;AACF;AAnLA;EExKE,mBF6LgD;AAiKlD;AE3VE;EACE,gCARmB;AFqWvB;AErhBE;EAuLA;IAII,iJAAA;EF8VJ;AACF;AAvKE;EEzJE,YF2JE;AAwKN;AEjUI;EACE,yBAAA;AFmUN;AA7KE;EEzJE,mBF2JE;AA8KN;AEvUI;EACE,gCAAA;AFyUN;AEtiBE;EAoOI;IACE,0MAAA;EFqUN;EEtUI;IACE,iNAAA;EFwUN;AACF;AAlLE;EElKE,YFoKE;AAmLN;AErVI;EACE,yBAAA;AFuVN;AAxLE;EElKE,mBFoKE;AAyLN;AE3VI;EACE,gCAAA;AF6VN;AE1jBE;EAoOI;IACE,0MAAA;EFyVN;EE1VI;IACE,iNAAA;EF4VN;AACF;AA7LE;EE3KE,YF6KE;AA8LN;AEzWI;EACE,yBAAA;AF2WN;AAnME;EE3KE,mBF6KE;AAoMN;AE/WI;EACE,gCAAA;AFiXN;AE9kBE;EAoOI;IACE,0MAAA;EF6WN;EE9WI;IACE,iNAAA;EFgXN;AACF;AAxME;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EExLA,YF2LE;AAwMN;AEjYI;EACE,yBAAA;AFmYN;AEhmBE;EAoOI;IACE,8MAAA;EF+XN;AACF;AA1ME;EEjME,YFmME;AA2MN;AE5YI;EACE,yBAAA;AF8YN;AAhNE;EEjME,kBFmME;AAiNN;AElZI;EACE,+BAAA;AFoZN;AEjnBE;EAoOI;IACE,0MAAA;EFgZN;EEjZI;IACE,gNAAA;EFmZN;AACF;AAtNI;EACE,eAAA;AAwNN;;AAnNA;EACE,aAAA;EEhNE,gBFkNA;AAqNJ;AEraI;EACE,6BAAA;AFuaN;AA3NA;EE/MI,iBFkNA;AA2NJ;AE3aI;EACE,8BAAA;AF6aN;AE1oBE;EAoOI;IACE,8MAAA;EFyaN;EE1aI;IACE,+MAAA;EF4aN;AACF;AAhOE;EExNE,YF0NE;AAiON;AEzbI;EACE,yBAAA;AF2bN;AAtOE;EExNE,iBF0NE;AAuON;AE/bI;EACE,8BAAA;AFicN;AE9pBE;EAoOI;IACE,8MAAA;EF6bN;EE9bI;IACE,2MAAA;EFgcN;AACF;AA3OE;EACE,OAAA;AA6OJ;AA1OE;EErOE,mBFuOE;AA2ON;AEhdI;EACE,gCAAA;AFkdN;AAhPE;EErOE,YFuOE;AAiPN;AEtdI;EACE,yBAAA;AFwdN;AErrBE;EAoOI;IACE,iNAAA;EFodN;EErdI;IACE,0MAAA;EFudN;AACF","sourcesContent":["@use '/src/scaffold/styles/variables' as vars;\n@use '/src/scaffold/styles/utilities' as utils;\n@use 'sass:math';\n\n// Static layout constants — not affected by viewport scale\n$tv-guide-header-height-base: 290px;\n$program-w-gap: 8px;\n\n/* \n  Base (1×) constants — keep in sync with tv-guide-helpers.ts\n  -MRA\n*/\n$minute-width-base: 14px;\n$program-height-base: 76px;\n$program-gap-base: 16px;\n$program-w-gap-base: 8px;\n$time-span-height-base: 40px + $program-gap-base;\n$channel-width-base: $program-height-base * 1.5;\n$grid-gap-base: 12px;\n$grid-offset-base: $channel-width-base + $grid-gap-base;\n\n// Scale-aware aliases — use these everywhere a dimension must shrink with the viewport.\n// --tv-scale is set by TvGuideView as a CSS custom property.\n$scale: var(--tv-scale, 1);\n$minute-width: calc(#{$scale} * #{$minute-width-base});\n$program-height: calc(#{$scale} * #{$program-height-base});\n$program-gap: calc(#{$scale} * #{$program-gap-base});\n$channel-width: calc(#{$scale} * #{$channel-width-base});\n$tv-guide-header-height: calc(#{$scale} * #{$tv-guide-header-height-base});\n$grid-gap: calc(#{$scale} * #{$grid-gap-base});\n$grid-offset: calc(#{$scale} * #{$grid-offset-base});\n$time-span-width: calc(#{$scale} * #{$minute-width-base} * 30);\n$time-span-height: calc(#{$scale} * #{$time-span-height-base});\n$navigation-header-height: calc(#{$scale} * #{vars.$header-height});\n\n.tv-guide {\n  position: relative;\n  background-color: vars.$color-background-primary;\n  overflow: hidden;\n  user-select: none;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n\n  @include utils.fluid-props(\n    (\n      margin-left: vars.$page-padding\n    )\n  );\n\n  height: calc(100vh - #{$navigation-header-height});\n\n  &__clock {\n    position: fixed;\n    top: 128px;\n    right: vars.$page-padding;\n  }\n\n  &__scrollable-x {\n    margin-left: $grid-offset;\n\n    @include utils.fluid-props(\n      (\n        margin-bottom: 72px\n      )\n    );\n  }\n  &__grid-area {\n    position: relative;\n    display: flex;\n    flex: 1;\n    min-height: 0;\n  }\n\n  &__button-container {\n    position: absolute;\n    top: 50%;\n    //this translates the button container up by 50% so the middle of the container gets centered instead of the top\n    transform: translateY(-50%);\n    right: 0;\n    margin-right: 16px;\n    z-index: 100;\n    width: auto;\n  }\n\n  &__arrow-button-bottom {\n    margin-top: 8px;\n  }\n\n  &__grid {\n    position: relative;\n    width: var(--grid-width);\n    height: var(--grid-height);\n  }\n\n  &__image {\n    position: fixed;\n    right: 0;\n    top: 0;\n    mask-image: radial-gradient(ellipse at 100% 27%, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 70%);\n    -webkit-mask-image: radial-gradient(\n      ellipse at 100% 27%,\n      rgba(0, 0, 0, 1) 20%,\n      rgba(0, 0, 0, 0) 70%\n    );\n    opacity: 1;\n    transition: opacity 300ms ease;\n\n    @include utils.fluid-props(\n      (\n        width: 1050px\n      )\n    );\n\n    &--hidden {\n      opacity: 0;\n    }\n  }\n}\n\n.tv-guide-more-info {\n  box-sizing: border-box;\n  user-select: none;\n  position: relative;\n  z-index: 1;\n\n  @include utils.fluid-props(\n    (\n      min-height: $tv-guide-header-height-base,\n      padding-right: vars.$page-padding\n    )\n  );\n\n  /*\n    This padding-top and padding-bottom are set to 0px at the largest breakpoint,\n    and then fluidly scales up to half the page padding at the \n    smallest breakpoint. This is done to ensure that the settings \n    page has a consistent look and feel across different screen sizes, \n    while also providing enough space for the content to breathe.\n    - MRA\n  */\n  @include utils.fluid-prop-range(padding-top, 0px, math.div(vars.$page-padding, 2));\n  @include utils.fluid-prop-range(padding-bottom, 0px, math.div(vars.$page-padding, 2));\n\n  &__period {\n    opacity: 0.5;\n  }\n\n  &__progress {\n    border-radius: 2px;\n    overflow: hidden;\n    opacity: 0;\n    transition: vars.$transition-base;\n\n    &--visible {\n      opacity: 1;\n    }\n\n    @include utils.fluid-props(\n      (\n        width: 392px,\n        margin-top: 16px,\n        height: 8px\n      )\n    );\n  }\n\n  &__progress-bar {\n    width: 100%;\n    border-radius: 2px;\n  }\n\n  &__buttons {\n    position: absolute;\n    display: flex;\n\n    @include utils.fluid-props(\n      (\n        right: vars.$page-padding,\n        bottom: 16px\n      )\n    );\n  }\n\n  &__button {\n    display: flex;\n    align-items: center;\n    color: vars.$color-white;\n    cursor: pointer;\n    z-index: 2;\n\n    @include utils.fluid-props(\n      (\n        margin-right: 32px\n      )\n    );\n\n    svg {\n      @include utils.fluid-props(\n        (\n          margin-right: 16px\n        )\n      );\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n\n.tv-guide-timeline {\n  position: relative;\n  display: flex;\n  left: $grid-offset;\n  width: calc(#{$scale} * #{$minute-width-base} * 30 * 48);\n  z-index: 2;\n  margin-bottom: 8px;\n  transform: translateX(var(--timeline-scroll));\n\n  &__item {\n    align-items: flex-end;\n    box-sizing: border-box;\n    display: flex;\n    height: $time-span-height;\n    width: $time-span-width;\n  }\n\n  &__item-text {\n    transform: translateX(-50%);\n  }\n}\n\n.tv-guide-live-marker {\n  position: absolute;\n  left: $grid-offset;\n  background-color: vars.$color-primary-dark;\n  pointer-events: none;\n  z-index: 2;\n  box-shadow: 0px 8px 22px #000000;\n  transform: translateX(var(--live-marker-offset-x, 0px));\n  height: var(--live-marker-height);\n\n  @include utils.fluid-props(\n    (\n      width: 6px\n    )\n  );\n}\n\n.tv-guide-channels {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  z-index: 3;\n  background-color: vars.$color-background-primary;\n\n  &__channel {\n    align-items: center;\n    border-radius: 6px;\n    display: flex;\n    height: $program-height;\n    margin-bottom: $program-gap;\n    justify-content: center;\n    overflow: hidden;\n    width: $channel-width;\n    z-index: 3;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n}\n\n.tv-guide-programs {\n  height: 100%;\n\n  &__row {\n    height: $program-height;\n  }\n  &__row-empty {\n    border: none;\n    margin: 0;\n    position: absolute;\n    left: 0;\n    width: 100%;\n    height: $program-height;\n    background-color: transparent;\n    cursor: pointer;\n\n    &--focused {\n      outline: 2px solid vars.$color-primary-main;\n    }\n  }\n\n  .tv-guide-program {\n    border: none;\n    text-align: left;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: $program-height;\n    padding-right: 24px;\n    padding-left: 24px;\n    background-color: #142435;\n    color: #4d5965;\n    box-sizing: border-box;\n    overflow: hidden;\n    transition: all 0.2s ease;\n    border-radius: 8px;\n    cursor: pointer;\n\n    top: var(--program-top-offset, 0px);\n    left: var(--program-left-offset, 0px);\n    width: var(--program-width, 0px);\n\n    &--highlighted {\n      background-color: #233342;\n      color: vars.$color-text-primary;\n    }\n\n    &--inactive {\n      background-color: #142435;\n      color: #4d5965;\n    }\n\n    &--selected {\n      background-color: vars.$color-white;\n      color: vars.$color-text-dark;\n    }\n\n    &--focused,\n    &:hover {\n      background-color: vars.$color-secondary-dark;\n      color: vars.$color-text-primary;\n    }\n\n    &--short {\n      padding-right: 0;\n      padding-left: 0;\n    }\n\n    &__container {\n      display: flex;\n      align-items: center;\n      flex: 1;\n      overflow: hidden;\n      transform: translateX(var(--program-text-offset, 0px));\n    }\n\n    &__text {\n      white-space: nowrap;\n      overflow: hidden;\n      min-width: 0;\n      text-overflow: ellipsis;\n      width: var(--program-text-width, 0px);\n    }\n\n    &__icons {\n      display: flex;\n      align-items: center;\n      position: absolute;\n      right: calc(#{$scale} * 16px);\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n    &__indicator {\n      width: calc(#{$scale} * 32px);\n      height: calc(#{$scale} * 32px);\n      flex-shrink: 0;\n\n      svg,\n      svg * {\n        fill: currentColor !important;\n        stroke: currentColor !important;\n      }\n    }\n  }\n}\n\n.tv-guide-dialog {\n  &__calendar-date-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n\n  &__edit-favorites {\n    margin-top: 8px;\n  }\n}\n\n/*\n  Skeleton styles\n*/\n.tv-guide-skeleton-info {\n  position: relative;\n\n  @include utils.fluid-props(\n    (\n      min-height: $tv-guide-header-height-base,\n      padding-right: vars.$page-padding,\n      margin-left: vars.$page-padding,\n      margin-right: vars.$page-padding\n    )\n  );\n\n  /*\n    This padding-top and padding-bottom are set to 0px at the largest breakpoint,\n    and then fluidly scales up to half the page padding at the \n    smallest breakpoint. This is done to ensure that the settings \n    page has a consistent look and feel across different screen sizes, \n    while also providing enough space for the content to breathe.\n    - MRA\n  */\n  @include utils.fluid-prop-range(padding-top, 0px, math.div(vars.$page-padding, 2));\n  @include utils.fluid-prop-range(padding-bottom, 0px, math.div(vars.$page-padding, 2));\n\n  &__title {\n    @include utils.fluid-props(\n      (\n        height: 85px,\n        margin-bottom: 16px\n      )\n    );\n  }\n\n  &__subtitle {\n    @include utils.fluid-props(\n      (\n        height: 50px,\n        margin-bottom: 16px\n      )\n    );\n  }\n\n  &__duration {\n    @include utils.fluid-props(\n      (\n        height: 45px,\n        margin-bottom: 16px\n      )\n    );\n  }\n\n  &__buttons {\n    position: absolute;\n    bottom: 16px;\n    right: 0;\n    display: flex;\n\n    @include utils.fluid-props(\n      (\n        width: 800px\n      )\n    );\n  }\n\n  &__button {\n    @include utils.fluid-props(\n      (\n        height: 56px,\n        margin-right: 32px\n      )\n    );\n\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n}\n\n.tv-guide-skeleton-grid {\n  display: flex;\n  @include utils.fluid-props(\n    (\n      margin-top: 56px,\n      margin-left: vars.$page-padding\n    )\n  );\n\n  &__channels {\n    @include utils.fluid-props(\n      (\n        width: 114px,\n        margin-right: 8px\n      )\n    );\n  }\n\n  &__programs {\n    flex: 1;\n  }\n\n  &__row {\n    @include utils.fluid-props(\n      (\n        margin-bottom: 16px,\n        height: 76px\n      )\n    );\n  }\n}\n","@use 'sass:math';\n\n$transition-base: all 0.15s ease;\n$network-log-width: 450px;\n$header-height: 150px;\n$page-padding: 88px;\n\n/* #region Responsive Framework */\n\n$breakpoint-sm: 880px;\n$breakpoint-ms: 1000px;\n$breakpoint-md: 1260px;\n$breakpoint-lg: 1320px;\n$breakpoint-xl: 1920px;\n$breakpoint-xxl: 1921px;\n// max for portrait collection\n$breakpoint-maxP: 2875px;\n// max for landscape collection\n$breakpoint-maxL: 3421px;\n\n$min-ratio-base: 0.65;\n\n/* #endregion */\n\n$dialog-max-width: $breakpoint-xl;\n$dialog-max-height: 1080px;\n$dialog-min-width: $breakpoint-sm;\n$dialog-sidebar-width: 695px;\n$dialog-sidebar-min-width: 250px;\n\n$player-sheet-width: 695px;\n\n/* #region Content Items */\n\n$media-item-min-ratio: 0.85;\n$media-item-max-ratio: 1.75;\n\n$portrait-width: 257px;\n$portrait-height: 367px;\n$portrait-ratio: math.div($portrait-height, $portrait-width) * 100%;\n$portrait-width-min: calc($portrait-width * $media-item-min-ratio);\n$portrait-width-max: calc($portrait-width * $media-item-max-ratio);\n\n$landscape-width: 406px;\n$landscape-height: 229px;\n$landscape-ratio: math.div($landscape-height, $landscape-width) * 100%;\n$landscape-width-min: calc($landscape-width * $media-item-min-ratio);\n$landscape-width-max: calc($landscape-width * $media-item-max-ratio);\n\n$wide-landscape-width: 554px;\n$wide-landscape-height: 214px;\n$wide-landscape-ratio: math.div($wide-landscape-height, $wide-landscape-width) * 100%;\n$wide-landscape-width-min: calc($wide-landscape-width * $media-item-min-ratio);\n$wide-landscape-width-max: calc($wide-landscape-width * $media-item-max-ratio);\n\n$provider-box-width: 257px;\n$provider-box-height: 168px;\n$provider-box-ratio: math.div($provider-box-height, $provider-box-width) * 100%;\n$provider-box-width-min: calc($provider-box-width * $media-item-min-ratio);\n$provider-box-width-max: calc($provider-box-width * $media-item-max-ratio);\n\n$content-item-logo-width: 50px;\n$content-item-logo-height: 32px;\n$content-item-logo-ratio: math.div($content-item-logo-height, $content-item-logo-width) * 100%;\n$content-item-logo-width-min: calc($content-item-logo-width * $media-item-min-ratio);\n$content-item-logo-width-max: calc($content-item-logo-width * $media-item-max-ratio);\n\n$back-icon-button-position: 12px;\n\n/* #endregion */\n\n/* #region Color Palette */\n\n// Shades\n$color-shades-secondary-20: #1f2b37;\n\n// Tints\n$color-tint-60: #011224;\n$color-tint-primary-10: #1a2a3a;\n$color-tint-primary-60: #99a0a7;\n$color-tint-secondary-10: #3d4a58;\n\n// Palette: Background\n$color-background-default: #252525;\n$color-background-primary: #011224;\n$color-background-secondary: #273645;\n$color-background-tertiary: #414d5b;\n$color-background-level1: #303030;\n$color-background-level2: #ccc;\n\n// Palette: Divider & Common\n$color-divider: #9e9e9e;\n$color-white: #f2f2f2;\n$color-black: #000;\n\n// Palette: Error\n$color-error-main: #f44336;\n$color-error-dark: #d32f2f;\n$color-error-secondary: #ffdb38;\n$color-error-contrast-text: #f2f2f2;\n\n// Palette: Grey\n$color-grey-light: #9b9b9b;\n$color-grey-main: #505050;\n$color-grey-dark: #303030;\n\n// Palette: Primary\n$color-primary-main: #369993;\n$color-primary-dark: #00c9a2;\n$color-primary-contrast-text: #000;\n\n// Palette: Secondary\n$color-secondary-main: #755ffa;\n$color-secondary-dark: #8370f1;\n$color-secondary-contrast-text: #000;\n\n// Palette: Tertiary\n$color-tertiary-main: rgba(65, 77, 91, 0.8);\n\n// Palette: Royal Blue\n$color-royalblue-main: #002b6b;\n$color-royalblue-dark: #3f82cf;\n\n// Palette: Light Purple\n$color-lightpurple-main: #e3e1ff;\n$color-lightpurple-dark: #e3e1ff;\n\n// Palette: Red\n$color-red-main: #f8232d;\n$color-red-dark: #f84049;\n\n// Palette: Success\n$color-success-main: #00c9a2;\n$color-success-light: #369993;\n\n// Palette: Text\n$color-text-primary: #f2f2f2;\n$color-text-primary-hover: #f2f2f2;\n$color-text-secondary: #9b9b9b;\n$color-text-secondary-hover: #f2f2f2;\n$color-text-dark: #011224;\n$color-text-tint-60: #93999f;\n\n// space indicators\n$color-space-indicator-recorded: #2ed28b;\n$color-space-indicator-scheduled: #3f82cf;\n$color-space-indicator-free: #f5f5ed;\n\n//#endregion\n\n/* #region Border Radius */\n\n$border-radius-sm: 4px;\n$border-radius-md: 8px;\n$border-radius-lg: 12px;\n\n/* #endregion */\n\n/* #region Typography */\n\n// Typography: Font Family\n$font-family: 'Norlys', sans-serif;\n$font-family-headline: 'Norlys Headline', sans-serif;\n\n// Typography: Weight\n$font-weight-light: 300;\n$font-weight-regular: 400;\n$font-weight-medium: 500;\n$font-weight-bold: 700;\n\n// min values are used for fluid typography, to ensure that the font size does not go below\n// a certain threshold on smaller screens. typically, the min value is set to half of the\n// max value, but it can be adjusted as needed.\n\n$typography-min-ratio: 0.85;\n\n// Typography: h1-h6, body, caption, button\n$h1-font-family: $font-family-headline;\n$h1-font-size: 88px;\n$h1-font-size-min: calc($h1-font-size * $typography-min-ratio);\n$h1-line-height: 1.36em; // was: 120px\n$h1-font-weight: $font-weight-bold;\n\n$h2-font-family: $font-family-headline;\n$h2-font-size: 72px;\n$h2-font-size-min: calc($h2-font-size * $typography-min-ratio);\n$h2-line-height: 1.36em; // was: 98px\n$h2-font-weight: $font-weight-bold;\n\n$h3-font-family: $font-family-headline;\n$h3-font-size: 60px;\n$h3-font-size-min: calc($h3-font-size * $typography-min-ratio);\n$h3-line-height: 1.4em; // was: 84px\n$h3-font-weight: $font-weight-regular;\n\n$h4-font-family: $font-family;\n$h4-font-size: 50px;\n$h4-font-size-min: calc($h4-font-size * $typography-min-ratio);\n$h4-line-height: 1.4em; // was: 70px\n$h4-font-weight: $font-weight-bold;\n\n$h5-font-family: $font-family;\n$h5-font-size: 42px;\n$h5-font-size-min: calc($h5-font-size * $typography-min-ratio);\n$h5-line-height: 1.33em; // was: 56px\n$h5-font-weight: $font-weight-regular;\n\n$h6-font-family: $font-family;\n$h6-font-size: 35px;\n$h6-font-size-min: calc($h6-font-size * $typography-min-ratio);\n$h6-line-height: 1.4em; // was: 49px\n$h6-font-weight: $font-weight-bold;\n\n$body-font-family: $font-family;\n$body-font-size: 32px;\n$body-font-size-min: calc($body-font-size * $typography-min-ratio);\n$body-line-height: 1.38em; // was: 44px\n$body-font-weight: $font-weight-regular;\n\n$body-small-font-family: $font-family;\n$body-small-font-size: 28px;\n$body-small-font-size-min: calc($body-small-font-size * $typography-min-ratio);\n$body-small-line-height: 1.39em; // was: 39px\n$body-small-font-weight: $font-weight-regular;\n\n$caption-font-family: $font-family;\n$caption-font-size: 24px;\n$caption-font-size-min: calc($caption-font-size * $typography-min-ratio);\n$caption-line-height: 1.46em; // was: 35px\n$caption-font-weight: $font-weight-bold;\n\n$caption2-font-family: $font-family;\n$caption2-font-size: 22px;\n$caption2-font-size-min: calc($caption2-font-size * $typography-min-ratio);\n$caption2-line-height: 1.27em; // was: 28px\n$caption2-font-weight: $font-weight-regular;\n\n/* #endregion */\n\n/* #region Button */\n$button-font-size: 24px;\n$button-font-size-min: calc($button-font-size * $typography-min-ratio);\n$button-height: 72px;\n$button-height-min: calc($button-height * $min-ratio-base);\n$button-width: 406px;\n$button-width-min: calc($button-width * $min-ratio-base);\n\n$button-sm-font-size: 22px;\n$button-sm-font-size-min: calc($button-sm-font-size * $typography-min-ratio);\n$button-sm-height: 56px;\n$button-sm-height-min: calc($button-sm-height * $min-ratio-base);\n\n$button-header-font-size: 32px;\n$button-header-font-size-min: calc($button-header-font-size * $typography-min-ratio);\n$button-header-height: 80px;\n$button-header-height-min: calc($button-header-height * $min-ratio-base);\n\n$button-icon-size: 40px;\n$button-icon-size-min: calc($button-icon-size * $typography-min-ratio);\n\n/* #endregion */\n\n/* #region Z-Index */\n\n$zindex-player-controls: 1250;\n$zindex-dialog: 1300;\n$zindex-overlay: 1400;\n$zindex-tooltip: 1500;\n\n/* #endregion */\n","@use 'sass:map';\n@use 'sass:math';\n@use 'sass:meta';\n@use '/src/scaffold/styles/variables' as vars;\n\n$spacing-step: 4px;\n\n$browser-scale-constant: 0.65;\n\n$breakpoints: (\n  sm: vars.$breakpoint-sm,\n  ms: vars.$breakpoint-ms,\n  md: vars.$breakpoint-md,\n  lg: vars.$breakpoint-lg,\n  xl: vars.$breakpoint-xl,\n  xxl: vars.$breakpoint-xxl,\n  maxP: vars.$breakpoint-maxP,\n  maxL: vars.$breakpoint-maxL\n);\n\n/*\n  The spacing function is a simple utility that takes a multiplier and returns the corresponding \n  spacing value based on the defined spacing step. This allows for easy adjustments to the overall \n  spacing of the app by simply changing the value of $spacing-step.\n\n  This is made only to mirror the spacing function in the design system.\n\n  - MRA\n*/\n\n@function spacing($multiplier) {\n  @return $spacing-step * $multiplier;\n}\n\n/*\n  The breakpoint mixins are utilities for handling responsive design. They allow you to write media queries \n  in a more readable and maintainable way by using named breakpoints defined in the $breakpoints map.\n\n  - MRA\n*/\n\n@function breakpoint($name) {\n  @if map.has-key($breakpoints, $name) {\n    @return map.get($breakpoints, $name);\n  }\n\n  @error 'Unknown breakpoint `#{$name}`. Available: #{map.keys($breakpoints)}';\n}\n\n@mixin respond-up($name) {\n  @media (min-width: breakpoint($name)) {\n    @content;\n  }\n}\n\n@mixin respond-down($name) {\n  @media (max-width: #{breakpoint($name) - 1px}) {\n    @content;\n  }\n}\n\n@mixin respond-between($min-name, $max-name) {\n  @media (min-width: breakpoint($min-name)) and (max-width: #{breakpoint($max-name) - 1px}) {\n    @content;\n  }\n}\n\n/*\n  Experimental\n\n  There are now two distinct fluid helpers in this file:\n\n  1. `fluid-props($map, $breakpoint)`\n     Keeps the existing behavior for a group of properties.\n     Static values are emitted first, and inside `respond-down($breakpoint)`\n     each property scales from the provided value down toward the `sm`\n     breakpoint using the original proportional logic.\n\n  2. `fluid-prop-range(...)`\n     Handles a single property with three explicit values:\n     - a base value, emitted outside any media query\n     - a min value, used for scaling down from `xl` to `sm`\n     - a max value, used for scaling up from `xxl` and above\n\n     The downscale path is a direct interpolation between the explicit\n     min and base values. The upscale path reuses the same proportional\n     viewport logic as the original helper, anchored to the base value,\n     and clamps the result so it never exceeds the explicit max value.\n\n  - MRA\n*/\n\n/*\n  Builds a clamp() expression from two explicit values and two explicit\n  breakpoints.\n\n  This is the low-level interpolation helper used when both endpoints are\n  known, for example when a property should be exactly 24px at `sm` and\n  exactly 40px at `xl`.\n*/\n\n@function fluid-between($min-value, $max-value, $min-breakpoint, $max-breakpoint) {\n  @if meta.type-of($min-value) != 'number' or meta.type-of($max-value) != 'number' {\n    $breakpoint-range: $max-breakpoint - $min-breakpoint;\n\n    @if $breakpoint-range <= 0px {\n      @error 'fluid-between requires max breakpoint to be larger than min breakpoint.';\n    }\n\n    @return clamp(\n      #{$min-value},\n      calc(#{$min-value} + (#{$max-value} - #{$min-value}) * ((100vw - #{$min-breakpoint}) / #{$breakpoint-range})),\n      #{$max-value}\n    );\n  }\n\n  $min-val-num: math.div($min-value, 1px);\n  $max-val-num: math.div($max-value, 1px);\n  $min-break-num: math.div($min-breakpoint, 1px);\n  $max-break-num: math.div($max-breakpoint, 1px);\n\n  @if $min-break-num >= $max-break-num {\n    @error 'fluid-between requires min breakpoint to be smaller than max breakpoint.';\n  }\n\n  $slope: math.div($max-val-num - $min-val-num, $max-break-num - $min-break-num);\n  $intercept: $min-val-num - ($slope * $min-break-num);\n  $clamp-min: math.min($min-val-num, $max-val-num);\n  $clamp-max: math.max($min-val-num, $max-val-num);\n\n  @return clamp(#{$clamp-min}px, calc(#{$intercept}px + #{$slope * 100}vw), #{$clamp-max}px);\n}\n\n/*\n  Recreates the original proportional scaling logic used by `fluid-prop`.\n\n  Only the upper value is supplied. The lower value is derived from the\n  ratio between the provided maximum value and its controlling breakpoint,\n  then passed through `fluid-between()` for the final clamp() expression.\n*/\n\n@function fluid-value($max-value, $min-breakpoint, $max-breakpoint) {\n  @if meta.type-of($max-value) != 'number' {\n    $ratio: math.div($min-breakpoint, $max-breakpoint);\n    $min-value: calc(#{$max-value} * #{$ratio});\n\n    @return fluid-between($min-value, $max-value, $min-breakpoint, $max-breakpoint);\n  }\n\n  $max-val-num: math.div($max-value, 1px);\n  $min-break-num: math.div($min-breakpoint, 1px);\n  $max-break-num: math.div($max-breakpoint, 1px);\n\n  @if $min-break-num >= $max-break-num {\n    @error 'fluid-value requires min breakpoint to be smaller than max breakpoint.';\n  }\n\n  $ratio: math.div($max-val-num, $max-break-num);\n  $min-value: $min-break-num * $ratio;\n\n  @return fluid-between($min-value * 1px, $max-value, $min-breakpoint, $max-breakpoint);\n}\n\n/*\n  Scales upward from a base value using the same proportional viewport logic\n  as the original helper, then clamps that growth to an explicit max value.\n\n  The ratio is anchored to the base value and its reference breakpoint.\n  In practice this means the property keeps its base value until the viewport\n  is large enough for the preferred fluid expression to exceed it, after which\n  it grows smoothly until the explicit max value is reached.\n*/\n\n@function fluid-max-value($base-value, $max-value, $base-breakpoint) {\n  @if meta.type-of($base-value) != 'number' or meta.type-of($max-value) != 'number' {\n    @return clamp(\n      #{$base-value},\n      calc((#{$base-value} / #{$base-breakpoint}) * 100vw),\n      #{$max-value}\n    );\n  }\n\n  $base-val-num: math.div($base-value, 1px);\n  $max-val-num: math.div($max-value, 1px);\n  $base-break-num: math.div($base-breakpoint, 1px);\n\n  @if $base-break-num <= 0 {\n    @error 'fluid-max-value requires a breakpoint larger than 0.';\n  }\n\n  @if $base-val-num > $max-val-num {\n    @error 'fluid-max-value requires max value to be greater than or equal to base value.';\n  }\n\n  $ratio: math.div($base-val-num, $base-break-num);\n\n  @return clamp(#{$base-val-num}px, calc(#{$ratio * 100}vw), #{$max-val-num}px);\n}\n\n@function fluid-prop($max-value, $min-name: sm, $max-name: xl) {\n  @return fluid-value($max-value, breakpoint($min-name), breakpoint($max-name));\n}\n\n/*\n  Single-property helper for the three-value case.\n\n  Output behavior:\n  - Base value is emitted directly, outside any media query.\n  - Inside `respond-down($base-name)`, the property scales from the explicit\n    min value up to the base value.\n  - If `$max-value` is provided, inside `respond-up($max-name)` the property\n    scales upward from the base value and is clamped so it never exceeds the\n    explicit max value.\n  - If `$max-value` is omitted (or `null`), no upscale media query is emitted.\n\n  Example:\n  @include utils.fluid-prop-range(font-size, 40px, 24px, 56px);\n\n  Example without max:\n  @include utils.fluid-prop-range(font-size, 40px, 24px);\n*/\n\n@mixin fluid-prop-range(\n  $prop,\n  $base-value,\n  $min-value,\n  $max-value: null,\n  $min-name: sm,\n  $base-name: xl,\n  $max-name: xxl\n) {\n\n  $browser-base-value: calc(#{ $base-value} * $browser-scale-constant);\n  $browser-min-value: calc(#{ $min-value} * $browser-scale-constant);\n  $browser-max-value: calc(#{ $max-value} * $browser-scale-constant);\n\n  #{$prop}: $base-value;\n\n  // Responsive functionality is now isolated to browser-mode\n  :global(.browser-mode) & {\n    #{$prop}: $browser-base-value;\n  \n    @include respond-down($base-name) {\n      #{$prop}: fluid-between($browser-min-value, $browser-base-value, breakpoint($min-name), breakpoint($base-name));\n    }\n\n    @if $max-value != null {\n      @include respond-up($max-name) {\n        #{$prop}: fluid-max-value($browser-base-value, $browser-max-value, breakpoint($base-name));\n      }\n    }\n  }\n}\n\n/*\n  Group-property helper for the original xl-to-sm scaling case.\n\n  Output behavior:\n  - Each property in the map is emitted first as a static base value,\n    outside any media query.\n  - Inside `respond-down($breakpoint)`, every property in the map is\n    recalculated with the original proportional fluid logic so it scales\n    down toward the `sm` breakpoint.\n\n  This helper is intended for the existing multi-property scenario where a\n  component has one shared upper breakpoint and each property should shrink\n  proportionally beneath it.\n\n  Examples:\n  @include utils.fluid-props((margin-top: 64px, margin-left: 52px));\n  @include utils.fluid-props((margin-top: 64px), $breakpoint: lg);\n*/\n@mixin fluid-props($map, $breakpoint: xl) {\n  @each $prop, $val in $map {\n    #{$prop}: $val;\n\n    :global(.browser-mode) & {\n      #{$prop}: calc(#{ $val} * $browser-scale-constant);\n    }\n  }\n\n\n  @include respond-down($breakpoint) {\n    @each $prop, $val in $map {\n      :global(.browser-mode) & {\n        #{$prop}: fluid-prop(calc(#{ $val} * $browser-scale-constant), sm, $breakpoint);\n      }\n    }\n  }\n}\n\n// END experimental\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tv-guide": `tv-guide__NibGY`,
	"tv-guide__clock": `tv-guide__clock__y5nvK`,
	"tv-guide__scrollable-x": `tv-guide__scrollable-x__O_zQy`,
	"tv-guide__grid-area": `tv-guide__grid-area__Fd3GK`,
	"tv-guide__button-container": `tv-guide__button-container__lX2Zj`,
	"tv-guide__arrow-button-bottom": `tv-guide__arrow-button-bottom__KYsY1`,
	"tv-guide__grid": `tv-guide__grid__x0zpc`,
	"tv-guide__image": `tv-guide__image__d4dXT`,
	"tv-guide__image--hidden": `tv-guide__image--hidden__aAyDq`,
	"tv-guide-more-info": `tv-guide-more-info__JIhUP`,
	"tv-guide-more-info__period": `tv-guide-more-info__period__kRDqL`,
	"tv-guide-more-info__progress": `tv-guide-more-info__progress__hj5gz`,
	"tv-guide-more-info__progress--visible": `tv-guide-more-info__progress--visible__eg5W0`,
	"tv-guide-more-info__progress-bar": `tv-guide-more-info__progress-bar__Hse4q`,
	"tv-guide-more-info__buttons": `tv-guide-more-info__buttons__Gkyq3`,
	"tv-guide-more-info__button": `tv-guide-more-info__button__MZB_N`,
	"tv-guide-timeline": `tv-guide-timeline__xyTct`,
	"tv-guide-timeline__item": `tv-guide-timeline__item__KiJqJ`,
	"tv-guide-timeline__item-text": `tv-guide-timeline__item-text__BMQxr`,
	"tv-guide-live-marker": `tv-guide-live-marker__o0XHT`,
	"tv-guide-channels": `tv-guide-channels__aLxf1`,
	"tv-guide-channels__channel": `tv-guide-channels__channel__G47fM`,
	"tv-guide-programs": `tv-guide-programs__GqEEH`,
	"tv-guide-programs__row": `tv-guide-programs__row__vd4o7`,
	"tv-guide-programs__row-empty": `tv-guide-programs__row-empty__mQMlS`,
	"tv-guide-programs__row-empty--focused": `tv-guide-programs__row-empty--focused__zdBsa`,
	"tv-guide-program": `tv-guide-program__b5R79`,
	"tv-guide-program--highlighted": `tv-guide-program--highlighted__FN2x3`,
	"tv-guide-program--inactive": `tv-guide-program--inactive__X6RGe`,
	"tv-guide-program--selected": `tv-guide-program--selected__J7tb5`,
	"tv-guide-program--focused": `tv-guide-program--focused__XqO_s`,
	"tv-guide-program--short": `tv-guide-program--short__l71WN`,
	"tv-guide-program__container": `tv-guide-program__container__yt_sj`,
	"tv-guide-program__text": `tv-guide-program__text__W2Rtu`,
	"tv-guide-program__icons": `tv-guide-program__icons__cfNMC`,
	"tv-guide-program__indicator": `tv-guide-program__indicator__rQG6x`,
	"tv-guide-dialog__calendar-date-row": `tv-guide-dialog__calendar-date-row__rCkzs`,
	"tv-guide-dialog__edit-favorites": `tv-guide-dialog__edit-favorites__XsGAD`,
	"tv-guide-skeleton-info": `tv-guide-skeleton-info__JZJqN`,
	"tv-guide-skeleton-info__title": `tv-guide-skeleton-info__title__DLIbj`,
	"tv-guide-skeleton-info__subtitle": `tv-guide-skeleton-info__subtitle__dc8wB`,
	"tv-guide-skeleton-info__duration": `tv-guide-skeleton-info__duration__OiwHW`,
	"tv-guide-skeleton-info__buttons": `tv-guide-skeleton-info__buttons__bpFH7`,
	"tv-guide-skeleton-info__button": `tv-guide-skeleton-info__button__hiGf5`,
	"tv-guide-skeleton-grid": `tv-guide-skeleton-grid__kRbzD`,
	"tv-guide-skeleton-grid__channels": `tv-guide-skeleton-grid__channels___eEuv`,
	"tv-guide-skeleton-grid__programs": `tv-guide-skeleton-grid__programs__sPwRG`,
	"tv-guide-skeleton-grid__row": `tv-guide-skeleton-grid__row__bIoRf`
};
export default ___CSS_LOADER_EXPORT___;
